import React, { useEffect } from "react";
import { Route, Redirect, useLocation, Navigate } from "react-router-dom";
import { useObserver } from "mobx-react-lite";
import User from "../../src/stores/UserStore";
import { observer } from "mobx-react";
// Import your Mobx store

const PrivateRoute = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    if (!User.info.personId) {
      // Save the current location so we can redirect back after login
      localStorage.setItem("redirectPath", location.pathname);
    }
  }, [location.pathname]);
  useEffect(() => {
    if (location.pathname == "/noc-apply") {
        const hash = location.hash;
        const hashValue = hash.substring(1);
      localStorage.setItem("nocType", hashValue);
    }
    if (location.pathname == "/dashboard") {
      const hash = location.hash;
      const hashValue = hash.substring(1); // Remove the '#' symbol
      localStorage.setItem("hash", hashValue);
    }
  }, []);

  if (!User.info.personId) {
    return <Navigate to="/" />;
  }
  return children;
};

export default observer(PrivateRoute);
